import React from "react";
import { PageHeader, TeamMember } from "../../components";
import TableTennisGallery from "./directory/tableTennis";

export default function TableTennis({ data }) {
  return (
    <div className="page-content">
      <PageHeader title="Table Tennis" page="table tennis" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact -> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div class="section-fullbg-gray content-inner bg-gray ">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="/assets/images/gallery/tt1.jpg"
                    alt=""
                    class="m-b30"
                  />
                </div>
                <div class="col-md-7 col-sm-12">
                  <h3 class="h2 text-uppercase">WELCOME TO Table Tennis</h3>
                  <div class="dlab-separator bg-primary"></div>
                  <h4 class="font-weight-500">Slogan: Growing Family</h4>
                  <h4 class="font-weight-3 00">
                    You are welcome to the Table table tennis Section of the
                    Lagos Country Club. The sports for the active mind and body,
                    loads of excitement awaits you with standard equipment in an
                    ambiance of total relaxation.
                  </h4>

                  <p>
                    The Table Tennis Section is one of the ten vibrant and
                    well-structured sections of Lagos Country Club — a home
                    where passion meets purpose, and where sport thrives
                    alongside deep-rooted camaraderie. True to our slogan,
                    “Growing Family”, we are a close-knit, ever-expanding
                    community bound by shared values of fellowship, fitness, and
                    fun.
                  </p>

                  <p>
                    Whether you’re a competitive player or a curious beginner,
                    our doors are always open. We have experienced and dedicated
                    coaches on hand daily, available to train and guide players
                    of all ages and skill levels. Our structured training
                    sessions ensure continuous improvement, while also nurturing
                    future champions.
                  </p>

                  <p>
                    We are proud to boast not just of our active calendar of
                    internal leagues, tournaments, and socials, but also of the
                    best lounge ambience in the entire club — a warm and stylish
                    space where members relax, connect, and unwind before or
                    after games.
                  </p>

                  <p>
                    From juniors to veterans, from tournaments to socials, the
                    Table Tennis Section is a lively intersection of sport,
                    meaningful friendships, mentorship and networking — making
                    us more than a section; we’re a growing family.
                  </p>

                  <p>Come rally with us — where every bounce builds bonds.</p>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Team member --> */}

          {/* <!-- Gallery section --> */}
          <TableTennisGallery />
          {/* <!--End Gallery section --> */}

          <TeamMember
            name="MR ABIODUN BAMGBADE "
            title="Chairman Table Tennis Sections."
            img="./assets/images/members/LCC_CHAIRMAN_TABLE_TENNIS.jpg"
          />
          {/* <!-- Team member --> */}
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
